export const PUBLISHED_PROCESS_DELETE_NOTE = 'Runs in progress will be cancelled.';
